const Blogs = Object.freeze({
  ECNews: 0,
  ECLegal: 1,
  ECLavoro: 2,
})

const PostHistoricalTypes = Object.freeze({
  Today: 0,
  Recent: 1,
  Historical: 2,
})

const blogNamesMap = new Map()
blogNamesMap.set(Blogs.ECNews, 'ecnews')
blogNamesMap.set(Blogs.ECLegal, 'eclegal')
blogNamesMap.set(Blogs.ECLavoro, 'eclavoro')

const EncryptedFlows = Object.freeze({
  JournalActivation: 1,
})

const Functionality = Object.freeze({
  Riviste: 1,
  Evolution: 2,
  Ebook: 4,
})

export {
  Blogs,
  PostHistoricalTypes,
  blogNamesMap,
  EncryptedFlows,
  Functionality,
}
